// components/Photos/PhotoUploader.tsx
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box } from '@chakra-ui/react'
import { Center, Button } from '@chakra-ui/react'

const PhotoSelector: React.FC<{ onImageSelected: (file: File) => void, photoDesc: string}> = ({ onImageSelected, photoDesc }) => {
    const onDrop = useCallback(async (files: File[]) => {
        console.log('starting upload', { files });
        const file = files[0];
        try {
            const uploadResult = await onImageSelected(file);
            return uploadResult;
        } catch (error) {
            console.error('Error selecting', error);
            throw error;
        }
    }, [0]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    return (
        <Box {...getRootProps()}>
            <Center>
                <Button colorScheme='blue'  p='5' m='5'>
                    <input {...getInputProps()} />
                    {
                        isDragActive
                            ? <p>Drop {photoDesc} here ...</p>
                            : <p>Upload {photoDesc}</p>
                    }
                </Button>
            </Center>
        </Box>
    );
};

export default PhotoSelector;

